// start:ng42.barrel
import './mortgage-status-popup.controller';
// end:ng42.barrel

